import { render, staticRenderFns } from "./fccEscolaridade.vue?vue&type=template&id=4c67b2d8"
import script from "./fccEscolaridade.vue?vue&type=script&lang=js"
export * from "./fccEscolaridade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports